import { useEffect } from 'react';

/**
 * Sets the document title for a page
 * @param {string} pageTitle - The page-specific title (e.g., "Music", "Background Music")
 */
export default function usePageTitle(pageTitle) {
  useEffect(() => {
    const baseTitle = 'Scorz ©';
    document.title = pageTitle ? `${baseTitle} - ${pageTitle}` : baseTitle;
    
    // Cleanup: reset to base title when component unmounts
    return () => {
      document.title = baseTitle;
    };
  }, [pageTitle]);
}
